import { ColumnElement } from '@atoms/columnElement';
import { VariableSelector } from '@atoms/dataSelectors/variableSelector/variableSelector';
import { InfoTooltip } from '@atoms/infoTooltip';
import { SwitchV2 } from '@atoms/switch';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@components/ui/card';
import { Label } from '@components/ui/label';
import type Model from '@models/base/base.model';
import type { AtomReference, SettingsData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = SettingsData & {
  sourceId: Model['id'];
  onShowEmptyTableChange: (value: boolean) => void;
  onAllowColumnsSelection: (allowColumnsSelection: boolean) => void;
  onDataSelectorPathReferenceSelected: (ref: Maybe<AtomReference>) => void;
};

export const TableSettings = observer(
  (props: React.PropsWithChildren<Props>) => (
    <Card>
      <CardHeader>
        <CardTitle>Table settings</CardTitle>
        <CardDescription>Additional table settings</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-6">
          <Column $width="240px">
            <ColumnElement>
              <div className="flex items-center gap-2">
                <Label>Primary key</Label>
                <InfoTooltip
                  description="The primary key of the table, ideally a unique identifier for each row."
                  title="Primary key"
                />
              </div>
              <VariableSelector
                onSelected={props.onDataSelectorPathReferenceSelected}
                placeholder="Select a primary key"
                selectedRef={props.dataSelectorPathReference}
                specificSourceIds={[props.sourceId]}
              />
            </ColumnElement>

            <ColumnElement>
              <SwitchV2
                checked={props.allowColumnsSelection}
                id="allow-columns-celection"
                labelText="Allow columns selection"
                onCheckedChange={props.onAllowColumnsSelection}
                tooltip={
                  <InfoTooltip
                    description="If enabled, the user will be able to select which columns to display or to hide using the Display button."
                    title="Allow columns selection"
                  />
                }
              />
            </ColumnElement>
            <ColumnElement>
              <SwitchV2
                checked={props.showEmptyTable}
                id="show-empty-table"
                labelText="Show empty table"
                onCheckedChange={props.onShowEmptyTableChange}
              />
            </ColumnElement>
          </Column>
          {props.children}
        </div>
      </CardContent>
    </Card>
  )
);
